<template>
	<base-modal
		ref="$modal"
		close-by-click-outside
		fullscreen-on-mobile
		@on-close="deactivateEsc"
		:loading="isLoading"
		width="900px"
		height="800px"
	>
		<app-tabs-old ref="$tabs" :tabs="tabs" v-model="activeTab">
			<template #info>
				<div v-if="!isLoading && clientInfo" class="client-info">
					<div class="client-info__header">
						<div class="client-info__header-left">
							<div class="client-info__field">
								<span class="client-info__field-name">{{ $t('client_label') }}:&nbsp;</span>
								<span class="client-info__field-value">{{ clientPage.client?.Name }}</span>
							</div>
							<div class="client-info__field">
								<span class="client-info__field-name">{{ $t('created_label') }}:&nbsp;</span>
								<span class="client-info__field-value">{{ formatDate(clientInfo.CreateTime) }}</span>
								<span
									v-if="clientInfo.Creator?.Name"
									class="client-info__field-value"
								> [{{ clientInfo.Creator.Name }}]</span>
							</div>
							<div class="client-info__field">
								<span class="client-info__field-name">{{ $t('last_edit_label') }}:&nbsp;</span>
								<span class="client-info__field-value">{{ formatDate(clientInfo.ChangeTime) }}</span>
								<span
									v-if="clientInfo.Changer?.Name"
									class="client-info__field-value"
								> [{{ clientInfo.Changer.Name }}]</span>
							</div>

							<div
								v-if="tags.length"
								class="client-info__field"
							>
								<span class="client-info__field-name">{{ $t('tags_upcase') }}:&nbsp;</span>
								<span class="client-info__field-value">
									{{ tags.map((t) => `#${t.Name}`).join(", ") }}
								</span>
							</div>
						</div>

						<div class="client-info__header-right">
							<app-lists
								ref="$lists"
								v-model="clientInfo.AnalyticsLists"
								:segment="CLIENT_SEGMENT"
								:element-id="clientIdRef"
							/>
						</div>
					</div>

					<div class="client-info__records">
						<div
							v-if="clientInfo.WorkerAttachmentLogs?.length"
							class="client-info__field client-info__field--col"
						>
							<div class="client-info__field-name">{{ $t('users_and_roles_label') }}:&nbsp;</div>
								<div
									v-for="(log, idx) in clientInfo.WorkerAttachmentLogs"
									:key="`w-${idx}`"
									class="client-info__field-value-col"
								>
									<span class="client-info__field-value-col-time">{{ formatDate(log.CreatedAt) }}&nbsp;</span>
									<span class="client-info__field-value-col-action">{{ log.Message }}</span>
								</div>
							</div>

							<div
								v-if="clientInfo.ProjectChangeRecords?.length"
								class="client-info__field client-info__field--col"
							>
								<div class="client-info__field-name">{{ $t('projects_label') }}:&nbsp;</div>
								<div
									v-for="(r, idx) in clientInfo.ProjectChangeRecords"
									:key="`p-${idx}`"
									class="client-info__field-value-col"
								>
									<span class="client-info__field-value-col-time">{{ formatDate(r.RecordDate) }}&nbsp;</span>
									<span class="client-info__field-value-col-action">
										[{{ r.Author?.Name }}] {{ $t(r.RecordType === 0 ? 'record_added' : 'record_removed') }}&nbsp;
									</span>
									<router-link
										v-if="r.Object"
										class="client-info__field-value-col-link"
										:to="{ query: { page: 'project', id: r.Object.Id } }"
									>
										{{ r.Object.Name }}
									</router-link>
								</div>
							</div>

							<div
								v-if="clientInfo.PersonChangeRecords?.length"
								class="client-info__field client-info__field--col"
							>
								<div class="client-info__field-name">{{ $t('contacts_label') }}:&nbsp;</div>
								<div
									v-for="(r, idx) in clientInfo.PersonChangeRecords"
									:key="`c-${idx}`"
									class="client-info__field-value-col"
								>
									<span class="client-info__field-value-col-time">{{ formatDate(r.RecordDate) }}&nbsp;</span>
									<span class="client-info__field-value-col-action">
										[{{ r.Author?.Name }}] {{ $t(r.RecordType === 0 ? 'record_added' : 'record_removed') }}&nbsp;
									</span>
									<span class="client-info__field-value-col-person">{{ r.Object?.Name }}</span>
								</div>
							</div>

							<div
								v-if="clientInfo.UnionChangeRecords?.length"
								class="client-info__field client-info__field--col"
							>
								<div class="client-info__field-name">{{ $t('holding') }}:&nbsp;</div>
								<div
									v-for="(r, idx) in clientInfo.UnionChangeRecords"
									:key="`u-${idx}`"
									class="client-info__field-value-col"
								>
									<span class="client-info__field-value-col-time">{{ formatDate(r.RecordDate) }}&nbsp;</span>
									<span class="client-info__field-value-col-union">
										[{{ r.Author?.Name }}]
										<template v-if="r.RecordType === 0">
											{{ $t('holding_created', { names: namesOf(r.ChangedClients) }) }}
										</template>
										<template v-else-if="r.RecordType === 1">
											{{ $t('holding_client_added', { names: namesOf(r.ChangedClients), holding: namesOf(r.UnchangedClients) }) }}
										</template>
										<template v-else-if="r.RecordType === 2">
											{{ $t('holding_client_removed', { names: namesOf(r.ChangedClients), holding: namesOf(r.UnchangedClients) }) }}
										</template>
										<template v-else-if="r.RecordType === 3">
											{{ $t('holding_disbanded', { names: namesOf(r.ChangedClients) }) }}
										</template>
									</span>
								</div>
							</div>
						</div>
					</div>
				</template>

			<template #rules>
				<main-permitions-tab
					:container="rulesContainer"
					:entity-id="clientIdRef"
					:can-edit="canEditRules"
					@save="onClose"
					@refresh="refreshRules"
					@cancel="onClose"
					type="client"
				/>
				<!-- <client-rules
					:container="rulesContainer"
					:client-id="clientIdRef"
					:can-edit="canEditRules"
					@refresh="refreshRules"
				/> -->
			</template>
		</app-tabs-old>
	</base-modal>
</template>

<script setup lang="ts">
import {
	computed,
	ref,
	watch
} from "vue";
import { i18n } from "@/i18n";

const t = (key: string): string => String(i18n.global.t(key));
import { useRoute } from "vue-router";
import moment from "moment";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppTabsOld from "@/components/ui-kit/tabs/AppTabsOld.vue";
import AppLists from "@/components/ui-kit/lists/AppLists.vue";
// import ClientAccessRulesTab from "./ClientAccessRulesTab.vue";
import MainPermitionsTab from "@/components/permitions/MainPermitionsTab.vue";
import ClientRules from "./ClientRules.vue";
import { ClientsApi } from "@/ api/ClientsApi";
import { AccessApi } from "@/ api/AccessApi";
import type { ClientInfoFull, AttachedEntityInChangeRecord } from "@/models/interfaces/client/client-info";
import { EntityRulesContainer } from "@/models/interfaces/access/entity-rules";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { clientPageStore } from "@/store/client-page";
import { workerStore } from "@/store/worker";
import { useModalEscape } from "@/composables/useModalEscape";

const CLIENT_SEGMENT = 1;

const route = useRoute();
const clientPage = clientPageStore();
const worker = workerStore();
const canEditRules = computed(() =>
	!!worker.workerProfile?.IsAdmin || clientPage.client?.RuleAccess === 1
);

// const tabs = clientPage.client?.RuleAccess == 1 ? [
// 	{ id: 0, title: "Информация о клиенте", slotName: "info" },
// 	{ id: 1, title: t("file_access_rights"), slotName: "rules" },
// ] : [
// 	{ id: 0, title: "Информация о клиенте", slotName: "info" },
// ];
const tabs = computed(() =>
  clientPage.client?.RuleAccess == 1
    ? [
        { id: 0, title: t("project_info_title"), slotName: "info" },
        { id: 1, title: t("file_access_rights"), slotName: "rules" },
      ]
    : [
        { id: 0, title: t("project_info_title"), slotName: "info" },
      ]
)

// const tabs = [ { id: 0, title: "Информация о клиенте", slotName: "info" },
// 	{ id: 1, title: "Права доступа", slotName: "rules" },
// ];

const $modal = ref<typeof BaseModal | null>(null);
const $lists = ref<InstanceType<typeof AppLists> | null>(null);
const $tabs = ref<InstanceType<typeof AppTabsOld> | null>(null);
const $content = computed<HTMLElement | null>(() => ($tabs.value?.$el as HTMLElement | null) ?? null);

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
	content: $content,
	close: () => $modal.value?.onClose()
});

const activeTab = ref<number>(0);
const isLoading = ref(false);
const clientInfo = ref<ClientInfoFull | null>(null);
const rulesContainer = ref<EntityRulesContainer | null>(null);
const clientIdRef = ref<number>(0);
const tags = ref<CommonEntityRecord[]>([]);

const formatDate = (date: string | undefined | null) => {
	if (!date) return "";
	return moment(date).format("HH:mm DD.MM.YYYY");
};

const namesOf = (items?: AttachedEntityInChangeRecord[]) =>
	(items ?? []).map((i) => i.Name).join(", ");

watch(activeTab, () => {
	$lists.value?.close();
});

const refreshRules = async () => {
	try {
		const rulesGiver = await AccessApi.getClientAccessRules(clientIdRef.value);
		rulesContainer.value = rulesGiver?.Container ?? null;
	} catch (e) {
		console.error(e);
	}
};

const onOpen = async (clientId: number, clientTags: CommonEntityRecord[] = []) => {
	try {
		clientIdRef.value = clientId;
		tags.value = clientTags;
		isLoading.value = true;
		activeTab.value = 0;
		clientInfo.value = null;
		rulesContainer.value = null;
		$modal.value?.onOpen();
		activateEsc();

		const [infoGiver, rulesGiver] = await Promise.all([
			ClientsApi.getClientInfo(clientId),
			AccessApi.getClientAccessRules(clientId).catch((e) => {
				console.error(e);
				return null;
			}),
		]);

		clientInfo.value = infoGiver ?? null;
		rulesContainer.value = rulesGiver?.Container ?? null;
	} catch (e) {
		console.error(e);
	} finally {
		isLoading.value = false;
	}
};

const onClose = () => {
	$modal.value?.onClose();
}

defineExpose({ onOpen });
</script>

<style scoped lang="scss">
@import "@/styles/color.scss";

:deep(.app-tabs) {
	overflow: hidden;
}

:deep(.app-tabs__content) {
	overflow: hidden;
}

:deep(.app-tabs__content-tab) {
	overflow-y: auto;
}

.client-info {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 12px 16px;

	&__header {
		display: flex;
		align-items: stretch;
		width: 100%;
		gap: 8px;

		&-left,
		&-right {
			display: flex;
			flex-direction: column;
			width: 100%;
		}

		&-left { flex: 2; }
		&-right { flex: 1; }
	}

	&__records {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	&__field {
		margin-bottom: 4px;
		font-size: 14px;
		line-height: 18px;
		overflow-wrap: anywhere;
		word-break: break-word;

		&--col {
			display: flex;
			flex-direction: column;
		}

		&-name {
			color: $color-text_main;
			font-weight: 500;
		}

		&-value {
			color: $color-text_main;
		}

		&-value-col {
			display: inline-block;
			overflow-wrap: anywhere;
			word-break: break-word;

			&-time { 
				color: #979797; 
			}

			&-name { 
				color: $color-text_main; 
			}

			&-action { 
				margin-left: 2px; 
				color: $color-text_main; 
			}

			&-person {
				color: $color-text_main;
				font-style: italic;
			}

			&-union {
				color: $color-text_main;
			}
		}
	}

}
</style>
